import { Fragment, type PropsWithChildren, type ReactNode } from "react";
import { Text, VStack } from "@chakra-ui/react";

type PreferenceGroupProps = {
  heading: string;
  children: ReactNode[] | ReactNode;
};

function GroupHeading({ children }: Required<PropsWithChildren>) {
  return (
    <Text
      casing={"uppercase"}
      fontWeight={700}
      size={"md"}
      alignSelf={"start"}
      color={"gray.400"}
    >
      {children}
    </Text>
  );
}

export function PreferenceGroup({ children, heading }: PreferenceGroupProps) {
  const childrenArray = Array.isArray(children) ? children : [children];
  return (
    <VStack gap={6} w={"100%"}>
      <GroupHeading>{heading}</GroupHeading>
      {childrenArray.map((child, index) => (
        <Fragment key={index}>{child}</Fragment>
      ))}
    </VStack>
  );
}
